import { useEffect, useState } from "react";
import "./HomePage.css";
import ImageSlider from "./ImageSlider";

import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { useNavigate } from "react-router-dom";
import { Divider } from "primereact/divider";

import { TabView, TabPanel } from "primereact/tabview";
import Navdetails from "../TopNavigation/HeadingNavigation"
import HeadingNavigation from "../TopNavigation/HeadingNavigation";

const HomePage = () => {
  const [allProductCars, setAllProductCars] = useState([]);
  const [allProductsBikes, setAllProductsBikes] = useState([]);
  const [allProductsCycle, setAllProductsCycle] = useState([]);
  const [allProductsToys, setAllProductsToys] = useState([]);
  const [allProductsGiftsAndArts, setAllProductsGiftsAndArts] = useState([]);

  const [showCarsOfHome, setShowCarsOfHome] = useState(true);
  const [showBikesOfHome, setShowBikesOfHome] = useState(false);
  const [showToysOfHome, setShowToysOfHome] = useState(false);
  const [showCyclesOfHome, setShowCyclesOfHome] = useState(false);
  const [showGiftsAndArtsOfHome, setShowGiftsAndArtsOfHome] = useState(false);

  const navigate = useNavigate();

  async function fetchProductDetails() {
    try {
      setAllProductCars([]);
      const res = await fetch(`/allCars`);
      const data = await res.json();
      if (!Array.isArray(data)) throw new Error("Data not in array format");
      setAllProductCars(data);
    } catch (err) {
      console.error("Product fetch error:", err.message);
    }
  }

  async function fetchAllBikesDetails() {
    try {
      setAllProductsBikes([]);
      const res = await fetch(`/allBikes`);
      const data = await res.json();
      if (!Array.isArray(data)) throw new Error("Data not in array format");
      setAllProductsBikes(data);
    } catch (err) {
      console.error("Bike fetch error:", err.message);
    }
  }

  async function fetchAllCyclesDetails() {
    try {
      setAllProductsCycle([]);
      const res = await fetch(`/allCycles`);
      const data = await res.json();
      if (!Array.isArray(data)) throw new Error("Data not in array format");
      setAllProductsCycle(data);
    } catch (err) {
      console.error("Cycle fetch error:", err.message);
    }
  }

  async function fetchAllToysDetails() {
    try {
      setAllProductsToys([]);
      const res = await fetch(`/allToys`);
      const data = await res.json();
      if (!Array.isArray(data)) throw new Error("Data not in array format");
      setAllProductsToys(data);
    } catch (err) {
      console.error("Toys fetch error:", err.message);
    }
  }

  async function fetchAllGiftsAndArtsDetails() {
    try {
      setAllProductsGiftsAndArts([]);
      const res = await fetch(`/allGiftsAndArts`);
      const data = await res.json();
      if (!Array.isArray(data)) throw new Error("Data not in array format");
      setAllProductsGiftsAndArts(data);
    } catch (err) {
      console.error("Gifts fetch error:", err.message);
    }
  }

  useEffect(() => {
    fetchProductDetails();
  }, []);

  // Add this to your state
  const [activeTabIndex, setActiveTabIndex] = useState(0);

  // Call the appropriate fetch function on tab change
  const handleTabChange = (e) => {
    setActiveTabIndex(e.index);
    switch (e.index) {
      case 0:
        setShowCarsOfHome(true);
        setShowBikesOfHome(false);
        setShowToysOfHome(false);
        setShowCyclesOfHome(false);
        setShowGiftsAndArtsOfHome(false);
        fetchProductDetails();
        break;
      case 1:
        setShowCarsOfHome(false);
        setShowBikesOfHome(true);
        setShowToysOfHome(false);
        setShowCyclesOfHome(false);
        setShowGiftsAndArtsOfHome(false);
        fetchAllBikesDetails();
        break;
      case 2:
        setShowCarsOfHome(false);
        setShowBikesOfHome(false);
        setShowToysOfHome(true);
        setShowCyclesOfHome(false);
        setShowGiftsAndArtsOfHome(false);
        fetchAllToysDetails();
        break;
      case 3:
        setShowCarsOfHome(false);
        setShowBikesOfHome(false);
        setShowToysOfHome(false);
        setShowCyclesOfHome(true);
        setShowGiftsAndArtsOfHome(false);
        fetchAllCyclesDetails();
        break;
      case 4:
        setShowCarsOfHome(false);
        setShowBikesOfHome(false);
        setShowToysOfHome(false);
        setShowCyclesOfHome(false);
        setShowGiftsAndArtsOfHome(true);
        fetchAllGiftsAndArtsDetails();
        break;
      default:
        break;
    }
  };

  return (
    <>
    <HeadingNavigation/>
      <div className="p-2">
        <ImageSlider />
      </div>
      <div className="m-3">
        <h2 className="text-center m-3">Product Catagories</h2>
        {/* <div className="flex">
          <Button
            className="ml-3"
            rounded
            size="small"
            severity="primary"
            onClick={() => {
              setShowCarsOfHome(true);
              setShowBikesOfHome(false);
              setShowToysOfHome(false);
              setShowCyclesOfHome(false);
              setShowGiftsAndArtsOfHome(false);
              fetchProductDetails();
            }}
          >
            Cars
          </Button>
          <Button
            className="ml-3"
            rounded
            size="small"
            severity="warning"
            onClick={() => {
              setShowCarsOfHome(false);
              setShowBikesOfHome(true);
              setShowToysOfHome(false);
              setShowCyclesOfHome(false);
              setShowGiftsAndArtsOfHome(false);
              fetchAllBikesDetails();
            }}
          >
            Bikes
          </Button>
          <Button
            className="ml-3"
            rounded
            size="small"
            severity="success"
            onClick={() => {
              setShowCarsOfHome(false);
              setShowBikesOfHome(false);
              setShowToysOfHome(true);
              setShowCyclesOfHome(false);
              setShowGiftsAndArtsOfHome(false);
              fetchAllToysDetails();
            }}
          >
            Toys
          </Button>
          <Button
            className="ml-3"
            rounded
            size="small"
            severity="info"
            onClick={() => {
              setShowCarsOfHome(false);
              setShowBikesOfHome(false);
              setShowToysOfHome(false);
              setShowCyclesOfHome(true);
              setShowGiftsAndArtsOfHome(false);
              fetchAllCyclesDetails();
            }}
          >
            Cycles
          </Button>
          <Button
            className="ml-3"
            rounded
            size="small"
            severity="secondary"
            onClick={() => {
              setShowCarsOfHome(false);
              setShowBikesOfHome(false);
              setShowToysOfHome(false);
              setShowCyclesOfHome(false);
              setShowGiftsAndArtsOfHome(true);
              fetchAllGiftsAndArtsDetails();
            }}
          >
            GiftsAndArts
          </Button>
        </div> */}

        <div className="px-3 md:px-5 lg:px-6 mt-4 custom-tabview">
          <TabView
            className="responsive-tabview"
            activeIndex={activeTabIndex}
            onTabChange={handleTabChange}
          >
            <TabPanel header="Cars" />
            <TabPanel header="Bikes" />
            <TabPanel header="Toys" />
            <TabPanel header="Cycles" />
            <TabPanel header="GiftsAndArts" />
          </TabView>
        </div>
        {/* <Divider /> */}

        {/* 🚗 Cars Section */}
        {showCarsOfHome && (
          <div className="flex flex-wrap justify-content-center gap-3 p-3 surface-100">
            {allProductCars.map((item) => (
              <Card
                key={item.id}
                className="w-full sm:w-20rem md:w-18rem text-center shadow-6"
                style={{ borderRadius: "30px" }}
              >
                <img
                  alt={item.productName}
                  src={`data:image/png;base64,${item.previewImg}`}
                  className="w-full border-round-md mt-2"
                  style={{ height: "12rem", width: "auto" }}
                />
                <span className="mt-3 text-base font-bold text-gray-800 block white-space-nowrap overflow-hidden text-overflow-ellipsis">
                  {item.productName}
                </span>
                <span>{`${item.ageGroup} Years`}</span>
                <p className="text-red-500 font-bold text-lg">₹{item.price}</p>
                <div className="flex justify-content-center">
                  <Button
                    onClick={() => {
                      navigate(`/carsById/${item.productID}`, {
                        state: { product: item },
                      });
                      sessionStorage.setItem("productId", item.productID);
                    }}
                    size="small"
                    severity="info"
                    rounded
                    className="mt-2"
                  >
                    View Product
                  </Button>
                </div>
              </Card>
            ))}
          </div>
        )}

        {/* 🏍️ Bikes Section */}
        {showBikesOfHome && (
          <div className="flex flex-wrap justify-content-center gap-3 p-3 surface-100">
            {allProductsBikes.map((item) => (
              <Card
                key={item.id}
                className="w-full sm:w-20rem md:w-18rem text-center shadow-6"
                style={{ borderRadius: "30px" }}
              >
                <img
                  alt={item.productName}
                  src={`data:image/png;base64,${item.previewImg}`}
                  className="w-full border-round-md mt-2"
                  style={{ height: "12rem", width: "auto" }}
                />
                <span className="mt-3 text-base font-bold text-gray-800 block white-space-nowrap overflow-hidden text-overflow-ellipsis">
                  {item.productName}
                </span>
                <span>{`${item.ageGroup} Years`}</span>
                <p className="text-red-500 font-bold text-lg">₹{item.price}</p>
                <div className="flex justify-content-center">
                  <Button
                    onClick={() => {
                      navigate(`/bikesById/${item.productID}`, {
                        state: { product: item },
                      });
                      sessionStorage.setItem("productId", item.productID);
                    }}
                    size="small"
                    severity="info"
                    rounded
                    className="mt-2"
                  >
                    View Product
                  </Button>
                </div>
              </Card>
            ))}
          </div>
        )}

        {/* 🧸 Toys Section */}
        {showToysOfHome && (
          <div className="flex flex-wrap justify-content-center gap-3 p-3 surface-100">
            {allProductsToys.map((item) => (
              <Card
                key={item.id}
                className="w-full sm:w-20rem md:w-18rem text-center shadow-6"
                style={{ borderRadius: "30px" }}
              >
                <img
                  alt={item.productName}
                  src={`data:image/png;base64,${item.previewImg}`}
                  className="w-full border-round-md mt-2"
                  style={{ height: "12rem", width: "auto" }}
                />
                <span className="mt-3 text-base font-bold text-gray-800 block white-space-nowrap overflow-hidden text-overflow-ellipsis">
                  {item.productName}
                </span>
                <span>{`${item.ageGroup} Years`}</span>
                <p className="text-red-500 font-bold text-lg">₹{item.price}</p>
                <div className="flex justify-content-center">
                  <Button
                    onClick={() => {
                      navigate(`/toysById/${item.productID}`, {
                        state: { product: item },
                      });
                      sessionStorage.setItem("productId", item.productID);
                    }}
                    size="small"
                    severity="info"
                    rounded
                    className="mt-2"
                  >
                    View Product
                  </Button>
                </div>
              </Card>
            ))}
          </div>
        )}

        {/* 🚲 Cycles Section */}
        {showCyclesOfHome && (
          <div className="flex flex-wrap justify-content-center gap-3 p-3 surface-100">
            {allProductsCycle.map((item) => (
              <Card
                key={item.id}
                className="w-full sm:w-20rem md:w-18rem text-center shadow-6"
                style={{ borderRadius: "30px" }}
              >
                <img
                  alt={item.productName}
                  src={`data:image/png;base64,${item.previewImg}`}
                  className="w-full border-round-md mt-2"
                  style={{ height: "12rem", width: "auto" }}
                />
                <span className="mt-3 text-base font-bold text-gray-800 block white-space-nowrap overflow-hidden text-overflow-ellipsis">
                  {item.productName}
                </span>
                <span>{`${item.ageGroup} Years`}</span>
                <p className="text-red-500 font-bold text-lg">₹{item.price}</p>
                <div className="flex justify-content-center">
                  <Button
                    onClick={() => {
                      navigate(`/productcycles/${item.productID}`, {
                        state: { product: item },
                      });
                      sessionStorage.setItem("productId", item.productID);
                    }}
                    size="small"
                    severity="info"
                    rounded
                    className="mt-2"
                  >
                    View Product
                  </Button>
                </div>
              </Card>
            ))}
          </div>
        )}

        {/* 🎨 Gifts & Arts Section */}
        {showGiftsAndArtsOfHome && (
          <div className="flex flex-wrap justify-content-center gap-3 p-3 surface-100">
            {allProductsGiftsAndArts.map((item) => (
              <Card
                key={item.id}
                className="w-full sm:w-20rem md:w-18rem text-center shadow-6"
                style={{ borderRadius: "30px" }}
              >
                <img
                  alt={item.productName}
                  src={`data:image/png;base64,${item.previewImg}`}
                  className="w-full border-round-md mt-2"
                  style={{ height: "12rem", width: "auto" }}
                />
                <span className="mt-3 text-base font-bold text-gray-800 block white-space-nowrap overflow-hidden text-overflow-ellipsis">
                  {item.productName}
                </span>
                <span>{`${item.ageGroup} Years`}</span>
                <p className="text-red-500 font-bold text-lg">₹{item.price}</p>
                <div className="flex justify-content-center">
                  <Button
                    onClick={() => {
                      navigate(`/giftsAndArtsById/${item.productID}`, {
                        state: { product: item },
                      });
                      sessionStorage.setItem("productId", item.productID);
                    }}
                    size="small"
                    severity="info"
                    rounded
                    className="mt-2"
                  >
                    View Product
                  </Button>
                </div>
              </Card>
            ))}
          </div>
        )}
      </div>
    </>
  );
};

export default HomePage;
